// API des auf UPLOAD beschraenkten Zugangs (/belege-upload). Bewusst klein: einrichten, status, hochladen, meine Uploads.
// Es gibt hier keine Anmeldung und keinen Zugriff auf andere Bereiche; das Geraete-Cookie (HttpOnly) verwaltet der Browser/Server.
import { API, NetzFehler } from "./belegeApi";

async function json(pfad, optionen = {}) {
  let res;
  try { res = await fetch(`${API}/belege-upload${pfad}`, optionen); } catch (e) { throw new NetzFehler("Keine Verbindung zum Server"); }
  const daten = await res.json().catch(() => ({}));
  if (!res.ok) { const f = new Error(typeof daten.detail === "string" ? daten.detail : `Fehler ${res.status}`); f.status = res.status; throw f; }
  return daten;
}

export const uploadApi = {
  status: () => json("/api/status"),
  einrichten: (token) => json("/api/einrichten", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }) }),
  meine: () => json("/api/meine"),
  manifestUrl: (token) => `${API}/belege-upload/manifest.webmanifest${token ? `?e=${encodeURIComponent(token)}` : ""}`,
  // Mit Fortschrittsanzeige (XMLHttpRequest, da fetch keinen Upload-Fortschritt meldet)
  hochladen: (formData, onFortschritt) => new Promise((ok, fehl) => {
    const x = new XMLHttpRequest();
    x.open("POST", `${API}/belege-upload/api/upload`);
    x.withCredentials = true;
    x.upload.onprogress = (e) => { if (e.lengthComputable && onFortschritt) onFortschritt(Math.round((e.loaded / e.total) * 100)); };
    x.onload = () => {
      let d = {}; try { d = JSON.parse(x.responseText); } catch (e) { /* leer */ }
      if (x.status >= 200 && x.status < 300) ok(d);
      else { const f = new Error(typeof d.detail === "string" ? d.detail : `Fehler ${x.status}`); f.status = x.status; fehl(f); }
    };
    x.onerror = () => fehl(new NetzFehler("Keine Verbindung zum Server"));
    x.ontimeout = () => fehl(new NetzFehler("Zeitueberschreitung"));
    x.timeout = 120000;
    x.send(formData);
  }),
};
